import React from "react";

import BasicDialog from "../../../Common/Dialog/BasicDialog";

const FormSubmitDialog = ({ onSave, onClose, open, type }) => {
    const onSubmit = () => {
        const params = {};
        onSave(params);
        onClose();
    };

    return (
        <BasicDialog
            title={`Submit ${type} for approval`}
            content={`When you are happy that you have completed all the required
     fields, you can submit your ${type} for approval.`}
            open={open}
            onClose={onClose}
            onSubmit={onSubmit}
            buttonLabel={"Submit"}
        />
    );
};

export default FormSubmitDialog;
